// import React, { useState } from "react";
// import "./serviceList.css";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
// import civil from "../../../assets/service2/civilEngg.jpeg";
// import archi from "../../../assets/service2/Archit.jpeg";
// import bor from "../../../assets/service2/BorFinder.jpeg";
// import BarBending from "../../../assets/service/BarBending2.jpg";
// import bordrill from "../../../assets/service/bordrill.jpg";
// import electrition from "../../../assets/service2/Electrian9.jpeg";
// import excavation from "../../../assets/service/excavation2.jpg";
// import IntriorCarpenter from "../../../assets/service2/Intiriar15.jpeg";
// import metsry from "../../../assets/service2/MestryConstruct.jpeg";
// import painter from "../../../assets/service2/Painter11.jpeg";
// import plumb from "../../../assets/service2/Plumber11.jpeg";
// import pop from "../../../assets/service/pop2.webp";
// import solar from "../../../assets/service/solar1.jpg";
// import TilesContractor from "../../../assets/service2/TilesLay.jpeg";

// import window from "../../../assets/service/metalWorl.jpg";
// import UseMediaQuery from "./../UseMediaQuery";

// const ServiceList = () => {
//   const isMobile = UseMediaQuery("(max-width:486px)");
//   const serviceList = [
//     { img: civil, name: "Civil Engineer" },
//     { img: archi, name: "Architect" },
//     { img: bor, name: "Borewell Point Finder" },
//     { img: bordrill, name: "Borewell Drilling Company" },
//     { img: excavation, name: "Excavation" },
//     { img: metsry, name: "Civil Contractor" },
//     { img: electrition, name: "Electrician" },
//     { img: BarBending, name: "Bar Bending" },
//     { img: plumb, name: "Plumber" },
//     { img: IntriorCarpenter, name: "Interior Carpenter" },
//     { img: painter, name: "Painter" },
//     { img: TilesContractor, name: "Tile’s Contractor" },
//     { img: window, name: "Metal Work (Window)" },
//     { img: pop, name: "POP" },
//     { img: solar, name: "Solar" },
//   ];

//   const [isFirstSlide, setIsFirstSlide] = useState(true);
//   const [isLastSlide, setIsLastSlide] = useState(false);
//   const mobile = UseMediaQuery();
//   const NextArrow = ({ onClick }) => (
//     <div
//       className={`topCArrow topCNext ${isLastSlide ? "iconHidden" : ""}`}
//       onClick={onClick}
//     >
//       <IoIosArrowForward />
//     </div>
//   );

//   const PrevArrow = ({ onClick }) => (
//     <div
//       className={`topCArrow topCPrev ${isFirstSlide ? "iconHidden" : ""}`}
//       onClick={onClick}
//     >
//       <IoIosArrowBack />
//     </div>
//   );

//   const settings = {
//     infinite: false,
//     slidesToShow: 5,
//     slidesToScroll: 2,

//     pauseOnHover: true,
//     nextArrow: <NextArrow />,
//     prevArrow: <PrevArrow />,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: { slidesToShow: 4 },
//       },
//       {
//         breakpoint: 768,
//         settings: { slidesToShow: 3 },
//       },
//       {
//         breakpoint: 486,
//         settings: { slidesToShow: 2.5 },
//       },
//     ],
//     beforeChange: (current, next) => {
//       setIsFirstSlide(next === 0);
//       setIsLastSlide(next === serviceList.length - 5);
//     },
//   };

//   return (
//     <>
//       {isMobile ? (
//         <div className="container-fluid p-0  mt-sm-2 mt-3">
//           {serviceList.length > 0 && (
//             <div className="row">
//               <h3 className="homehTag my-xl-5 my-xxl-5 my-lg-5 my-md-2 my-sm-1 my-1 text-center">
//                 Explore all our services in one smart app.
//               </h3>
//               <h3 className="homehTag my-xl-5 my-xxl-5 my-lg-5 my-md-2 my-sm-1 my-1">
//                 Labour / Technician
//               </h3>
//               <div className="">
//                 <Slider {...settings}>
//                   {serviceList.map((item, i) => (
//                     <div key={i} className="serviceItem text-center ">
//                       <img
//                         src={item.img}
//                         alt={item.name}
//                         className="serviceImg"
//                       />
//                       <p className="serviceName">{item.name}</p>
//                     </div>
//                   ))}
//                 </Slider>
//               </div>
//             </div>
//           )}
//         </div>
//       ) : (
//         <div className="container mt-xxl-3 mt-xl-3  mt-lg-3 mt-md-3 mt-sm-2 mt-2 ">
//           {serviceList.length > 0 && (
//             <div className="row">
//               <h3 className="cardTextAni mt-xxl-3 mt-xl-3  mt-lg-3 mt-md-3 mt-sm-2 mt-2mb-xl-5 mb-xxl-5 mb-lg-5 mb-md-2 mb-sm-1 mb-1 text-center">
//                 Explore all our services in one smart app.
//               </h3>
//               <h3 className="homehTag my-xl-3 my-xxl-3 my-lg-3 my-md-2 my-sm-1 my-1">
//                 Labour / Technician
//               </h3>
//               <div className="my-1">
//                 <Slider {...settings}>
//                   {serviceList.map((item, i) => (
//                     <div key={i} className="serviceItem text-center my-1">
//                       <img
//                         src={item.img}
//                         alt={item.name}
//                         className="serviceImg"
//                       />
//                       <p className="serviceName">{item.name}</p>
//                     </div>
//                   ))}
//                 </Slider>
//               </div>
//             </div>
//           )}
//         </div>
//       )}
//     </>
//   );
// };

// export default ServiceList;

// import React, { useState, useEffect, useRef } from "react";
// import "./serviceList.css";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
// import civil from "../../../assets/service2/civilEngg.jpeg";
// import archi from "../../../assets/service2/Archit.jpeg";
// import bor from "../../../assets/service2/borDrill11.jpeg";
// import BarBending from "../../../assets/service2/barBendding11.jpeg";
// import bordrill from "../../../assets/service2/BorFinder.jpeg";
// import electrition from "../../../assets/service2/Electrian9.jpeg";
// import excavation from "../../../assets/service2/excavation11.jpeg";
// import IntriorCarpenter from "../../../assets/service2/tilespage1.jpeg";
// import metsry from "../../../assets/service2/MestryConstruct.jpeg";
// import builder from "../../../assets/service2/builder1.jpg";
// import painter from "../../../assets/service2/painterpage1.jpeg";
// import plumb from "../../../assets/service2/plumberpage5.png";
// import pop from "../../../assets/service2/pop11.jpeg";
// import solar from "../../../assets/service2/solar11.jpeg";
// import TilesContractor from "../../../assets/service2/TilesLay.jpeg";
// import window from "../../../assets/service2/windowSet11.jpeg";
// import UseMediaQuery from "./../UseMediaQuery";

// const ServiceList = () => {
//   const isMobile = UseMediaQuery("(max-width:486px)");
//   const headingRef = useRef(null); // <- ref for scroll animation

//   const [isFirstSlide, setIsFirstSlide] = useState(true);
//   const [isLastSlide, setIsLastSlide] = useState(false);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           headingRef.current.setAttribute("data-scrolled", "true");
//         }
//       },
//       { threshold: 0.4 }
//     );

//     if (headingRef.current) {
//       observer.observe(headingRef.current);
//     }

//     return () => {
//       if (headingRef.current) observer.unobserve(headingRef.current);
//     };
//   }, []);

//   const serviceList = [
//     { img: civil, name: "Civil Engineer" },
//     { img: metsry, name: "Civil Contractor (Mestry)" },
//     { img: builder, name: "Builder" },
//     { img: excavation, name: "Excavation (JCB)" },
//     { img: bordrill, name: "Borewell Point Finder" },
//     { img: bor, name: "Borewell Drilling Company" },
//     { img: archi, name: "Architect" },

//     { img: BarBending, name: "Bar Bending" },
//     { img: electrition, name: "Electrician" },

//     { img: plumb, name: "Plumber" },
//     { img: IntriorCarpenter, name: "Interior Carpenter" },
//     { img: window, name: "Metal Work" },
//     { img: painter, name: "Painter" },
//     { img: TilesContractor, name: "Tile’s Contractor" },

//     { img: pop, name: "POP" },
//     { img: solar, name: "Solar" },
//   ];

//   const NextArrow = ({ onClick }) => (
//     <div
//       className={`topCArrow topCNext ${isLastSlide ? "iconHidden" : ""}`}
//       onClick={onClick}
//     >
//       <IoIosArrowForward />
//     </div>
//   );

//   const PrevArrow = ({ onClick }) => (
//     <div
//       className={`topCArrow topCPrev ${isFirstSlide ? "iconHidden" : ""}`}
//       onClick={onClick}
//     >
//       <IoIosArrowBack />
//     </div>
//   );

//   const settings = {
//     infinite: false,
//     slidesToShow: 5,
//     slidesToScroll: 2,
//     pauseOnHover: true,
//     nextArrow: <NextArrow />,
//     prevArrow: <PrevArrow />,
//     responsive: [
//       { breakpoint: 1024, settings: { slidesToShow: 4 } },
//       { breakpoint: 768, settings: { slidesToShow: 3 } },
//       { breakpoint: 486, settings: { slidesToShow: 2.5 } },
//     ],
//     beforeChange: (current, next) => {
//       setIsFirstSlide(next === 0);
//       setIsLastSlide(next === serviceList.length - 5);
//     },
//   };

//   return (
//     <div className={isMobile ? "container-fluid   mt-3" : "container mt-0"}>
//       {serviceList.length > 0 && (
//         <div className="row">
//           <h3
//             ref={headingRef}
//             className="cardTextAni mt-xxl-5 mt-xl-5 mt-lg-5  mt-3 mb-xl-2 mb-xxl-2 mb-lg-2 mb-md-2 mb-sm-1 mb-1 text-center"
//           >
//             Explore all our services in one smart App
//           </h3>

//           <h3 className="homehTag my-xl-4 my-xxl-4 my-lg-4 my-md-2 my-sm-1 my-1">
//             Labour / Technician
//           </h3>

//           <div className="my-1">
//             <Slider {...settings}>
//               {serviceList.map((item, i) => (
//                 <div key={i} className="serviceItem text-center mt-1">
//                   <img src={item.img} alt={item.name} className="serviceImg" />
//                   <p className="serviceName mb-0">{item.name}</p>
//                 </div>
//               ))}
//             </Slider>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ServiceList;

import React, { useState, useEffect, useRef } from "react";
import "./serviceList.css";
import civil from "../../../assets/service2/civilEngg.jpeg";
import archi from "../../../assets/service2/Archit.jpeg";
import bor from "../../../assets/service2/borDrill11.jpeg";
import BarBending from "../../../assets/service2/barBendding11.jpeg";
import bordrill from "../../../assets/service2/BorFinder.jpeg";
import electrition from "../../../assets/service2/Electrian9.jpeg";
import excavation from "../../../assets/service2/excavation11.jpeg";
import IntriorCarpenter from "../../../assets/service2/tilespage1.jpeg";
import metsry from "../../../assets/service2/MestryConstruct.jpeg";
import builder from "../../../assets/service2/builder1.jpg";
import painter from "../../../assets/service2/painterpage1.jpeg";
import plumb from "../../../assets/service2/plumberpage5.png";
import pop from "../../../assets/service2/pop11.jpeg";
import solar from "../../../assets/service2/solar11.jpeg";
import TilesContractor from "../../../assets/service2/TilesLay.jpeg";
import window from "../../../assets/service2/windowSet11.jpeg";
import UseMediaQuery from "./../UseMediaQuery";

const ServiceList = () => {
  const isMobile = UseMediaQuery("(max-width:486px)");
  const headingRef = useRef(null); // <- ref for scroll animation

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          headingRef.current.setAttribute("data-scrolled", "true");
        }
      },
      { threshold: 0.4 }
    );

    if (headingRef.current) {
      observer.observe(headingRef.current);
    }

    return () => {
      if (headingRef.current) observer.unobserve(headingRef.current);
    };
  }, []);

  const serviceList = [
    { img: civil, name: "Civil Engineer" },
    { img: metsry, name: "Civil Contractor (Mestry)" },
    { img: builder, name: "Builder" },
    { img: excavation, name: "Excavation (JCB)" },
    { img: bordrill, name: "Borewell Point Finder" },
    { img: bor, name: "Borewell Drilling Company" },
    { img: archi, name: "Architect" },

    { img: BarBending, name: "Bar Bending" },
    { img: electrition, name: "Electrician" },

    { img: plumb, name: "Plumber" },
    { img: IntriorCarpenter, name: "Interior Carpenter" },
    { img: window, name: "Metal Work" },
    { img: painter, name: "Painter" },
    { img: TilesContractor, name: "Tile’s Contractor" },

    { img: pop, name: "POP" },
    { img: solar, name: "Solar" },
  ];
  // <div className="container-fluid serviceBgOne">
  return (
    <div className="container-fluid serviceBgOne">
      <div
        className={
          isMobile
            ? "container-fluid   my-4 serviceMargin "
            : "container mt-0 mb-xl-5 mb-lg-5 mb-md-4 mb-sm-3 "
        }
      >
        {serviceList.length > 0 && (
          <div className="row">
            <h3
              ref={headingRef}
              className="cardTextAni mt-xxl-5 mt-xl-5 mt-lg-5  mt-3 mb-xl-2 mb-lg-2 mb-md-2 mb-sm-1 mb-1 text-center"
            >
              Explore all our services in one smart App
            </h3>

            <h3 className="homehTag mt-xl-4 mt-xxl-4 mt-lg-4 mt-md-3 mt-sm-3 mt-3">
              Labour / Technician
            </h3>

            <div className="col-12 d-flex flex-wrap mb-xl-5 mb-lg-5 mb-md-4 mb-sm-3 mb-2">
              {serviceList.map((item, i) => (
                <div
                  key={i}
                  className="col-6 col-md-4 col-sm-4 col-lg-3 mt-xl-3 mt-lg-3 mt-md-2 mt-2 "
                >
                  <div className="serviceItem text-center">
                    <img
                      src={item.img}
                      alt={item.name}
                      className="serviceImg  "
                    />
                    <p className="serviceName mb-xl-0 mb-lg-0 mb-2 ">
                      {item.name}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ServiceList;
